import { getSelectors } from '@repo/core'
import { bankingProductsDataSelectorConfig } from './bankingProductsData'

export const bankingProductsDataSelector = getSelectors({
  getRootPath: bankingProductsDataSelectorConfig.bankingProductsDataSelector.getRootPath,
})
